var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('app-header')]},proxy:true},{key:"banner",fn:function(){return [_c('Banner',{attrs:{"title":_vm.title}})]},proxy:true},{key:"default",fn:function(){return [_c('ContactForm')]},proxy:true},{key:"footer",fn:function(){return [_c('app-footer')]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ddecb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = null
// module chunks = 